import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, RefreshCcw, Heart, Sparkles, MessageCircle } from 'lucide-react';
import { questions, results } from './TransferLoveData';
import KakaoShareButton from './KakaoShareButton';

const TransferLoveTest = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0); 
  const [currentIdx, setCurrentIdx] = useState(0);
  const [scores, setScores] = useState({ E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 });
  const [mbti, setMbti] = useState("");

  const handleAnswer = (value) => {
    const newScores = { ...scores, [value]: scores[value] + 1 };
    setScores(newScores);

    if (currentIdx + 1 < questions.length) {
      setCurrentIdx(currentIdx + 1);
    } else {
      const res = [
        newScores.E >= newScores.I ? "E" : "I",
        newScores.S >= newScores.N ? "S" : "N",
        newScores.T >= newScores.F ? "T" : "F",
        newScores.J >= newScores.P ? "J" : "P"
      ].join("");
      setMbti(res);
      setStep(2);
    }
  };

  if (step === 0) return (
    <div className="min-h-screen bg-rose-50 flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-10 border-4 border-rose-200">
        <Heart size={60} className="mx-auto text-rose-500 mb-6 animate-pulse" />
        <h1 className="text-3xl font-black mb-2 text-gray-800">내가 환승연애 출연자라면?</h1>
        <p className="text-rose-400 font-bold mb-8">나의 출연 포지션 분석 테스트</p>
        <button onClick={() => setStep(1)} className="w-full bg-rose-500 text-white font-bold py-5 rounded-2xl text-xl shadow-lg">하우스 입주하기</button>
      </div>
    </div>
  );

  if (step === 1) return (
    <div className="min-h-screen bg-rose-50 flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8">
        <div className="h-2 w-full bg-gray-100 rounded-full mb-8">
          <div className="h-2 bg-rose-400 rounded-full transition-all" style={{ width: `${((currentIdx + 1) / questions.length) * 100}%` }}></div>
        </div>
        <h2 className="text-xl font-bold mb-8 text-gray-800 leading-snug">{questions[currentIdx].text}</h2>
        <div className="space-y-4">
          {questions[currentIdx].answers.map((ans, i) => (
            <button key={i} onClick={() => handleAnswer(ans.value)} className="w-full bg-gray-50 hover:bg-rose-50 border-2 border-gray-100 py-4 px-6 rounded-2xl text-left font-bold transition-all">
              {ans.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  if (step === 2) {
    const res = results[mbti] || results["INFP"];
    return (
      <div className="min-h-screen bg-rose-100 flex flex-col items-center justify-center p-6 text-center">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-white">
          <div className="p-10 bg-rose-500 text-white">
            <p className="font-bold opacity-80 mb-2">당신의 출연진 캐릭터는?</p>
            <h2 className="text-3xl font-black mb-4">{res.name}</h2>
            <div className="text-8xl mb-4">{res.emoji}</div>
          </div>
          <div className="p-10">
            <p className="text-gray-700 text-lg mb-8 leading-relaxed font-medium">"{res.desc}"</p>
            <div className="bg-rose-50 p-4 rounded-xl mb-8 font-bold text-rose-800 tracking-tight">⭐ 당신의 X는 누구일까요? 궁금하면 공유!</div>
            <KakaoShareButton title={`내가 환승연애 출연자라면? 결과: ${res.name}`} description={res.desc} />
            <button onClick={() => window.location.reload()} className="w-full mt-4 py-4 bg-gray-100 rounded-2xl font-bold flex items-center justify-center gap-2"><RefreshCcw size={20}/> 다시하기</button>
            <button onClick={() => navigate('/')} className="w-full mt-2 py-4 text-gray-400 font-bold">홈으로 가기</button>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default TransferLoveTest;
